<div class="filters">
  <div class="card">
    <div class="card-body" *ngIf="loading">
      <div class="loading-page">
        <div class="loading-spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </div>
    </div>
    <div class="card-header" *ngIf="!loading">
      <p class="mb-0"><strong>Filtrar Infrações</strong></p>
    </div>
    <div class="card-body" *ngIf="!loading">
      <form [formGroup]="filterForm">
        <app-input i18n-label
          label="Enquadramentos"
          type="multiselect"
          formControlName="regulations" [list]="regulations"
          selectText="prettyNames"
          selectValue="id"
          placeholder="Selecione"
          selectShowLimit="1">
        </app-input>
        <app-input i18n-label
          label="Pontos"
          type="multiselect"
          formControlName="spots" [list]="spots"
          selectText="prettyNames"
          selectValue="code"
          placeholder="Selecione"
          selectShowLimit="1">
        </app-input>
        <app-input i18n-label
          label="Faixas"
          type="multiselect"
          formControlName="lanes" [list]="lanes"
          selectText="prettyNames"
          selectValue="code"
          placeholder="Selecione"
          selectShowLimit="1">
        </app-input>
        <app-input i18n-label
          label="Classificação Veicular"
          type="multiselect"
          formControlName="classification" [list]="classifications"
          selectText="description"
          selectValue="id"
          placeholder="Selecione"
          selectShowLimit="1">
        </app-input>
        <app-input i18n-label
          label="Intervalo de Atualização"
          type="select"
          formControlName="refreshDelay" [list]="refreshDelay"
          selectText="description"
          selectValue="code"
          placeholder="Selecione"
          selectShowLimit="1">
        </app-input>
        <app-input i18n-label
          label="Quantidade de Registros"
          type="select"
          formControlName="registerAmount" [list]="registerAmount"
          selectText="description"
          selectValue="code"
          placeholder="Selecione"
          selectShowLimit="1">
        </app-input>
        <mat-checkbox i18n
          color="primary"
          formControlName="enableNotPlate">
          Considerar Registros sem Placa
        </mat-checkbox>
      </form>
    </div>
    <div class="card-footer" *ngIf="!loading">
      <div class="d-flex justify-content-between">
        <button
          class="btn btn-outline-secondary ml-3"
          (click)="resetFilters()">
          Redefinir
        </button>
        <button
          class="btn btn-primary mr-3"
          (click)="applyFilters()">
          Confirmar
        </button>
      </div>
    </div>
  </div>
</div>
